import React from "react";
import { FormLabel, RequiredIndicator } from "assets/js/Styles";
import { Col, Row } from "reactstrap";
import CustomSelect from "components/customs/dropdown";
import { addProjectDropdownStyles } from "constants/style";
import styled from "styled-components";

const HouseMemberSection = styled(Row)`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

const HouseMemberColRight = styled.div`
  display: grid;
  grid-template-columns: 1fr 107px;

  @media screen and (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

const FundSourceSection = ({
  index,
  fundSourceOptions,
  projectRecipients,
  setProjectRecipients,
  setSelectedFundSource,
  selectedFundSource,
}) => {
  return (
    <HouseMemberSection>
      <Col
        xs="12"
        md="6"
      >
        <FormLabel>
          {"Fund Source"}
          {RequiredIndicator}
        </FormLabel>
        <p>{"Provide the fund source"}</p>
      </Col>
      <Col
        xs="12"
        md="6"
      >
        <HouseMemberColRight>
          <CustomSelect
            placeholder="Fund Source"
            styles={addProjectDropdownStyles}
            options={fundSourceOptions}
            onChange={(option) => {
              const newProjectRecipients = [...projectRecipients];

              newProjectRecipients[index] = {
                ...newProjectRecipients[index],
                fundSource: option,
              };

              setProjectRecipients(newProjectRecipients);
              setSelectedFundSource(option);
            }}
            value={selectedFundSource}
          />
        </HouseMemberColRight>
      </Col>
    </HouseMemberSection>
  );
};

export default FundSourceSection;
